export default __webpack_public_path__ + "00cee23.png";